import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { getSpecialityData } from '../reduxactions/adminactions/ASpecialityActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API } from '../ApiNames';
import { StepperPanel } from 'primereact/stepperpanel';
import { Stepper } from 'primereact/stepper';
import { fetchAppointments, fetchCloseCases, fetchOpenCases } from '../reduxactions/doctoractions/PatientHistoryActions';

export const PatientHistory = () => {
    const uid = window.sessionStorage.getItem('uid');
    const location = useLocation();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const [globalFilter, setGlobalFilter] = useState('');

    const open = useSelector((state: RootState) => state.patienthistory.open);
    const close = useSelector((state: RootState) => state.patienthistory.close);
    const appointments = useSelector((state: RootState) => state.patienthistory.appointments);
    const dispatch = useDispatch();
    const stepperRef = useRef(null);



    //To get data
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchOpenCases(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchDataAsync3 = async () => {
        try {
            await dispatch(fetchCloseCases(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync4 = async () => {
        try {
            await dispatch(fetchAppointments(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync1();
        fetchDataAsync3();
        fetchDataAsync4();

    }, [dispatch]);
    const navigate = useNavigate()
    const ViewOpenCase = (rowData: any) => {
        const url = `/casedetails/${rowData.cid}`;
        console.log('rowdata:', rowData.cid)
        navigate(url);
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/doctorpatienthisory.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="main-content">
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2"></div>
                            <div className="box box-primary">
                                <div className="card"></div>
                                <div className="card flex flex-wrap justify-content">

                                </div>
                                <div className="col-16" style={{ textAlign: "right" }}>
                                    <a
                                        title="help"
                                        onClick={(e) => openWindow(e, IUrl)}
                                        style={{

                                            color: "blue",
                                            fontSize: 15, cursor: "pointer"
                                        }}
                                    >Help for this Page &nbsp;
                                        <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                    </a>
                                </div>
                                <div className="card">
                                    <Stepper ref={stepperRef}>
                                        <StepperPanel header="Open Cases">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={open} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['name', 'date', 'Phone', 'Status']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="name" sortable header="Doctor Name" />
                                                            <Column field="date" sortable header="Date"></Column>
                                                            <Column header="Status" sortable body={(rowData) => rowData.status ? rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase() : ''} />
                                                            <Column field="cid" sortable header="CaseID"></Column>

                                                            <Column header="Operations" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewOpenCase(rowData)} />

                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>
                                        <StepperPanel header="Close Cases">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={close} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['name', 'date', 'Phone', 'Status']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="name" sortable header="Doctor Name" />
                                                            <Column field="date" sortable header="Date"></Column>
                                                            <Column header="Status" sortable body={(rowData) => rowData.status ? rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase() : ''} />
                                                            <Column header="Operations" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewOpenCase(rowData)} />

                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>
                                        <StepperPanel header="Appointments">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={appointments} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['name', 'date', 'duration', 'desc']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="name" sortable header="Patient Name" />
                                                            <Column field="date" sortable header="Appointment Date" />
                                                            <Column field="duration" sortable header="Duration"></Column>
                                                            <Column field="desc" sortable header="Description"></Column>
                                                            {/* <Column header="Operations" body={(rowData) => (
                                                        <div className="options-buttons">
                                                            
                                                        </div>
                                                    )}></Column> */}
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>

                                    </Stepper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </div >
    )
}
